// Get all anchor elements with the class 'model-select'
const modelSelectAnchors = document.querySelectorAll('.model-select');
function toggleModal(){
    let modalSelector = document.querySelector('.product__model-info .product__model-selector');
        if(modalSelector){
           modalSelector.classList.toggle('product__model-selector--active');
        }  
  }
modelSelectAnchors.forEach(anchor => {
    anchor.addEventListener('click', function(event) {
        event.preventDefault();

        // Get the value of the 'data-product-template' attribute
        const productTemplate = this.getAttribute('data-product-template');

        // Remove 'model-select--active' class from all anchors and add to the clicked one
        modelSelectAnchors.forEach(anchor => {
            anchor.classList.remove('model-select--active');
        });
        this.classList.add('model-select--active');

        // Get all elements with the class 'product-size-gallery'
        const galleries = document.querySelectorAll('.product-size-gallery');

        // Hide all galleries and remove 'hidden' class from the corresponding one
        galleries.forEach(gallery => {
            gallery.classList.add('hidden');
            if (gallery.getAttribute('data-product-template') === productTemplate) {
                gallery.classList.remove('hidden');
                toggleModal();
               
            }
        });

        // Hide all elements with the class 'gallery-wrap default-gallery'
        const defaultGalleries = document.querySelectorAll('.gallery-wrap.default-gallery');
        defaultGalleries.forEach(gallery => {
            gallery.classList.add('hidden');
        });
    });
});
